import { authClient, API } from "../../utils/index";

/** Solo plantillas publicadas (editor escape room, portal). */
export const getPlantillas = () => {
	return authClient().get(`${API}/plantilla`);
};

/** Todas las plantillas, incl. borradores (solo admin, menú backoffice). */
export const getPlantillasAdmin = () => {
	return authClient().get(`${API}/plantilla?all=1`);
};

export const getPlantillaById = (id) => {
	return authClient().get(`${API}/plantilla/${id}`);
};

export const postPlantilla = (body) => {
	return authClient().post(`${API}/plantilla`, body);
};

export const putPlantilla = (id, body) => {
	return authClient().put(`${API}/plantilla/${id}`, body);
};

export const publishPlantilla = (id) => {
	return authClient().post(`${API}/plantilla/${id}/publish`);
};

export const deletePlantilla = (id) => {
	return authClient.delete(`${API}/plantilla/${id}`);
};
